import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const NoResults = () => {
  return (
    <Box paddingX="s48" paddingY="s32" textAlign="center">
      <h2>
        <Text.Normal size="200" weight="medium">
          {i18n.t('company_settings.no_results.title')}
        </Text.Normal>
      </h2>
      <Text.Normal size="200">{i18n.t('company_settings.no_results.description')}</Text.Normal>
    </Box>
  )
}

export default NoResults
